import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { InputComponent } from "@components/input/input.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { ProduktSearchRequestDTO } from "~app/common/models/produkt/ProduktSearchRequestDTO";
import { Produkt } from "~app/common/models/produkt/ProduktSearchResponseDTO";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { StatedataService, Volatile } from "~app/common/services/statedata.service";
import { FormModeName, TabName } from "../../produkt-detail/produkt-details.models";
import { ProduktService } from "../../produkt.service";

@Component({
    selector: "rask-produkt-search-panel",
    templateUrl: "./produkt-search-panel.component.html",
    styleUrls: ["./produkt-search-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        RadiobuttonGroupComponent,
        SubmitButtonComponent,
        TranslatePipe
    ]
})
export class ProduktSearchPanelComponent implements OnInit {
    activetypes: IRadiobuttonItem[] = [
        { key: "true",
            value: "Ja" },
        { key: "false",
            value: "Nej" },
        { key: "",
            value: "Alla" }
    ];
    form: UntypedFormGroup;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("searchresult") searchresult = new EventEmitter<Produkt[]>(true);
    volatile: Volatile;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly produktService = inject(ProduktService);
    private readonly raskBusy = inject(BusyService);
    private readonly router = inject(Router);
    private readonly statedataService = inject(StatedataService);

    constructor() {
        this.volatile = this.statedataService.getVolatile();
    }

    canCreate(): boolean {
        return this.authenticationService.canEdit();
    }

    create(): void {
        this.router.navigate([
            "/produkt",
            FormModeName.New,
            TabName.basdata
        ]);
    }

    do_search(searchParams: ProduktSearchRequestDTO): void {
        this.raskBusy.addWork(this.produktService.search(searchParams)).subscribe(res => {
            this.volatile.set("searchparams", searchParams);

            this.searchresult.emit(res.produkter);
        });
    }

    ngOnInit() {
        let searchParams = this.volatile.get<ProduktSearchRequestDTO>("searchparams");

        if (searchParams) {
            this.do_search(searchParams);
        } else {
            searchParams = new ProduktSearchRequestDTO();
            searchParams.aktiv = true;
        }

        this.form = this.formBuilder.group(searchParams);
        this.form.get("aktiv").setValue(searchParams.aktiv ? "true" : "false");
    }

    parseFalsyString(val) {
        if (val == null || val === "") {
            return null;
        }

        return val === "true" ? true : false;
    }

    search(): void {
        const searchParams = new ProduktSearchRequestDTO();
        searchParams.produktnamn = this.form.get("produktnamn").value;
        searchParams.produktgrupp = this.form.get("produktgrupp").value;
        searchParams.handelssortiment = this.form.get("handelssortiment").value;
        searchParams.sortimentskod = this.form.get("sortimentskod").value;
        searchParams.tradslag = this.form.get("tradslag").value;
        searchParams.beteckning = this.form.get("beteckning").value;
        searchParams.aktiv = this.parseFalsyString(this.form.get("aktiv").value);
        this.do_search(searchParams);
    }
}
